import * as React from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { Autocomplete, IconButton, TextField, Tooltip, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import Grid from "@mui/material/Grid2"
import { Button } from "@mui/material"
import { emailRegex } from "../../Constants"

export default function EmailModal({
    open,
    closeModal,
    title = "Email To",
    providedEmail = "",
    options_list = [], // [{ value: "a@a.com", name: "Preferred Contact" }]
    acceptEmpty = false,
}) {
    const [email, setEmail] = React.useState(providedEmail)

    const submit = (e) => {
        e.preventDefault();
        closeModal && closeModal(email.toLowerCase())
    }

    const valid_email = Boolean(email.toLowerCase().match(emailRegex)) || (acceptEmpty && email.length === 0)

    React.useEffect(() => {
        if (open) {
            setEmail(providedEmail)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [providedEmail, open])

    return (
        <div>
            <Dialog
                open={open}
                onClose={() => closeModal && closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth='sm'
                fullWidth
            >
                <form onSubmit={submit}>
                    <DialogTitle>
                        <span style={{ "paddingRight": "24px" }}>{title}</span>
                        <IconButton
                            aria-label="close"
                            onClick={() => closeModal && closeModal(false)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        {!(options_list?.length > 0) &&
                            <TextField
                                autoFocus
                                fullWidth
                                margin="dense"
                                id="email"
                                label="Email"
                                type="email"
                                variant="filled"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                sx={{ minWidth: '250px' }}
                            />
                        }
                        {options_list?.length > 0 &&
                            <Autocomplete
                                options={options_list}
                                value={email}
                                isOptionEqualToValue={(option, value) => option.value === value}
                                getOptionLabel={(option) => option.value ?? option}
                                onChange={(event, newValue) => {
                                    setEmail(newValue?.value ?? '');
                                }}
                                onInputChange={(event, newInputValue) => {
                                    setEmail(newInputValue ?? '');
                                }}
                                freeSolo
                                renderInput={(params) => {
                                    return (<TextField {...params} autoFocus label="Email" variant="filled" type="email" fullWidth autoComplete='off' />)
                                }}
                                renderOption={(props, option, { inputValue }) => {
                                    const { key, ...optionProps } = props;

                                    return (
                                        <li key={option.value} {...optionProps}>
                                            <div>
                                                <span>
                                                    {option.value}
                                                </span>
                                                <br />
                                                <Typography sx={{ opacity: '50%', fontSize: '.7rem', pl: 1 }}>{option.name}</Typography>
                                            </div>
                                        </li>
                                    );
                                }}
                            />
                        }
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                            <Grid xs="auto">
                            </Grid>
                            <Grid xs="auto">
                                <Tooltip title={!valid_email && 'Email is not valid'}>
                                    <span> {/* span required for tooltip events */}
                                        <Button variant="contained" type="submit" disabled={!valid_email}>
                                            Submit
                                        </Button>
                                    </span>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    )
}
